/**
 * @module axios配置
 */
import axios from 'axios'
import { Dialog } from 'vant';
// import { config } from './config'

// 权限前缀
let myAxios = axios.create({})

// 超时时间设置
myAxios.defaults.timeout = 10000;
axios.defaults.withCredentials = true;
axios.defaults.crossDomain = true;
axios.defaults.dataType = 'json';
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
myAxios.defaults.baseURL = process.env.NODE_ENV === 'production' ? window.location.origin:'/api';
// axios请求拦截
myAxios.interceptors.request.use(conf => {
  // // 设置 token
  // conf.headers['Content-Type'] = 'application/json;charset=UTF-8';
  // api 处理
  return conf
})

// axios返回拦截
myAxios.interceptors.response.use(
  response => {
    let patt1 = new RegExp("cas/login");
    if(patt1.test(response.request.responseURL)){
      window.location.href = response.request.responseURL;
      return Promise.reject(302);
    }else{
      if(response.status === 200){
          return Promise.resolve(response.data ? response.data:response)
      }else{
        return Promise.reject(response);
      }
    }
  },
  error => {
    if(error.response){
      let msg='';
      if(error.response.status === 403){
        msg="权限不足或会话超时，请重新登录";
      }else
      if(error.response.status === 404){
        msg="页面找不到，请联系运维人员";
      }else
      if(error.response.status === 500){
        msg="内部服务错误，请联系运维人员";
       
      }else
      if(error.response.status === 550){
        msg="页面找不到，请联系运维人员";
      }else{
        msg="未知错误类型，请联系运维人员";
      }
      Dialog.alert({
        message: msg
      }).then(() => {
        return Promise.reject(error.response);
      });
    }
    return Promise.reject(302)
  }
)



 export default myAxios

//  export default {
//    name:myAxios,
//   components: {
//     [Dialog.name]: Dialog
//   }
// }

